import '@kp/geofy-vuejs-lib/tg-system.css';
import './assets/main.scss';
import './plugins/dayjs';
import '@kanton-thurgau/design-system/cdk/accordion';
import '@kanton-thurgau/design-system/accordion';
import '@kanton-thurgau/design-system/action-list';
import '@kanton-thurgau/design-system/alert-banner';
import '@kanton-thurgau/design-system/breadcrumbs';
import '@kanton-thurgau/design-system/buttons';
import '@kanton-thurgau/design-system/card';
import '@kanton-thurgau/design-system/checkbox';
import '@kanton-thurgau/design-system/clues';
import '@kanton-thurgau/design-system/date-input';
import '@kanton-thurgau/design-system/dropdown';
import '@kanton-thurgau/design-system/field';
import '@kanton-thurgau/design-system/file-input';
import '@kanton-thurgau/design-system/footer';
import '@kanton-thurgau/design-system/horizon';
import '@kanton-thurgau/design-system/icon';
import '@kanton-thurgau/design-system/label';
import '@kanton-thurgau/design-system/labelled-choice';
import '@kanton-thurgau/design-system/line';
import '@kanton-thurgau/design-system/link';
import '@kanton-thurgau/design-system/loader';
import '@kanton-thurgau/design-system/main-navigation';
import '@kanton-thurgau/design-system/message-feed';
import '@kanton-thurgau/design-system/modal';
import '@kanton-thurgau/design-system/pill';
import '@kanton-thurgau/design-system/progress-bar';
import '@kanton-thurgau/design-system/radio';
import '@kanton-thurgau/design-system/table';
import '@kanton-thurgau/design-system/tabs';
import '@kanton-thurgau/design-system/toggle';
import '@kanton-thurgau/design-system/tooltip';
import '@kanton-thurgau/design-system/text-area';
import '@kanton-thurgau/design-system/text-input';
import '@kanton-thurgau/design-system/vertical-navigation';
import '@kanton-thurgau/design-system/cdk/accordion';
import '@kanton-thurgau/design-system/map';
import '@kanton-thurgau/design-system/phone-input';
import '@kanton-thurgau/design-system/number-input';
import { useGeofyGlobals } from '@kp/geofy-vuejs-lib/tools/geofy_globals.js';
import { useGeofyLayers } from '@kp/geofy-vuejs-lib/tools/geofy_layers.js';

import { createApp } from 'vue';
// import PrimeVue from 'primevue/config';
import { init as apiInit, loadAuthInfo, instance as api } from '@/helpers/api';
import { setupI18n, setupLocale } from '@/helpers/i18n';
import App from './App.vue';
import router from './router';
import { setGlobals, setSession, useSession, useAuthUser } from '@/helpers/globals';
import { storeCsrfToken } from '@/helpers/auth';

// Read VITE env variables: to be set BEFORE the build,
// either in webroot/frontend/.env[mode][.local] or override via ENV vars:
const apiRoot = import.meta.env.VITE_API_BASE;
const appRoot = import.meta.env.VITE_BASE_URL;

// we wrap the call in an async wrapper function, as we cannot have
// module-level async calls:
(async () => {
    // Pre-loading API info before we start the app
    apiInit(apiRoot, appRoot);
    const authInfo = await loadAuthInfo();
    setGlobals(authInfo?.globals || {});
    setSession({
        user: authInfo?.user || null,
        csrfToken: authInfo?.csrfToken || null
    });
    storeCsrfToken(useSession().csrfToken);
    const locale = useAuthUser()?.locale ?? 'de';
    const result = await setupLocale(locale);
    const messages = result;

    // only if logged in, we load additional data:
    if (useAuthUser()) {
        const layersResult = await api().get('/PlanningPermissionApplication/geofyLayers');
        const layers = layersResult.data?.layers;
        const geofyConfig = layersResult.data?.config;
        const { init: geofyGlobalInit } = useGeofyGlobals();
        geofyGlobalInit(geofyConfig);
        useGeofyLayers().init(layers || []);
    }

    const app = createApp(App);

    app.use(router);
    app.use(setupI18n(locale, messages));
    app.mount('#app');
})();
